import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_DELETE_USER, ASYNC_RESTORE_USER } from 'store';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { api } from 'services';
import Dialog from 'react-bootstrap-dialog';
import { useTranslation } from 'react-i18next';
import MasterPage from 'components/MasterPage';
import Listing from 'components/Listing';
import Can from 'components/Can';
import { DashboardOutlined } from '@material-ui/icons';

const UsersList = ({ deleteUser, trash, restoreUser }) => {
  const defaultFilters = { search: '', per_page: 10, page: 1 };
  const [data, setData] = useState({ data: [] });

  const [filters, setFilters] = useState(defaultFilters);

  let dialog;

  useEffect(() => {
    api
      .get(!trash ? 'users' : 'users/trash')
      .then(({ data }) => setData(data));
  }, [trash]);

  useEffect(() => {
    api
      .get(!trash ? 'users' : 'users/trash', { params: { ...filters } })
      .then(({ data }) => setData(data));
  }, [filters, trash]);

  const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const effectDeleteUser = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:user delete'),
      body: t('phrase:are you sure?'),
      actions: [Dialog.CancelAction(), Dialog.OKAction(() => deleteUser(id))],
      bgSize: 'small',
    });
  };

  const effectRestoreUser = (id) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:user restore'),
      body: t('phrase:are you sure?'),
      actions: [Dialog.CancelAction(), Dialog.OKAction(() => restoreUser(id))],
      bgSize: 'small',
    });
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Dialog
          ref={(component) => {
            dialog = component;
          }}
        />
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">
              {!!trash ? t('title:trash') + ': ' : ''}
              {t('title:users list')}
            </h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row className="mb-5">
              <Col>
                {!trash ? (
                  <>
                    <Can do="createUser" on="App">
                      <Button
                        size="sm"
                        className="login-btn mr-1"
                        variant="primary-login"
                        as={Link}
                        to="/users/create"
                      >
                        <i className="fas fa-plus"></i> {t('label:add new')}
                      </Button>
                    </Can>
                    &nbsp;
                    <Button
                      size="sm"
                      variant="secondary"
                      as={Link}
                      to="/users/trash"
                    >
                      <i className="fas fa-trash"></i> {t('label:view trash')}
                    </Button>
                  </>
                ) : (
                    <Button size="sm" className="login-btn mr-1" variant="primary-login" as={Link} to="/users">
                      <i className="fas fa-arrow-left"></i> {t('label:go back')}
                    </Button>
                  )}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Listing
                  fields={[
                    { name: 'id' },
                    {
                      name: 'name',
                      type: 'custom',
                      value: (flatten, dt) => `${dt.firstname} ${dt.lastname} `,
                    },
                    { name: 'email', key: 'email', type: 'string' },
                    { name: 'phone', key: 'phone', type: 'string' },
                  ]}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  data={data}
                  handleFilterChange={handleFilterChange}
                  actions={
                    !trash
                      ? [
                        (user, k) => (
                          <Can do="editUser" on="App">
                            <Button
                              size="sm"
                              key={k}
                              as={Link}
                              to={`/users/edit/${user.id}`}
                              variant="light"
                              alt={t('title:edit')}
                              title={t('title:edit')}
                            >
                              <i className="fas fa-pen"></i>
                            </Button>
                          </Can>
                        ),
                        (user, k) => (
                          <Can do="deleteUser" on="App">
                            <Button
                              size="sm"
                              key={k}
                              className="ml-1"
                              variant="danger"
                              onClick={() => effectDeleteUser(user.id)}
                              alt={t('title:delete')}
                              title={t('title:delete')}
                            >
                              <i className="fas fa-times"></i>
                            </Button>
                          </Can>
                        ),
                      ]
                      : [
                        (user, k) => (
                          <Can do="deleteUser" on="App">
                            <Button
                              size="sm"
                              key={k}
                              variant="secondary"
                              onClick={() => effectRestoreUser(user.id)}
                              alt={t('title:restore')}
                              title={t('title:restore')}
                            >
                              <i className="fas fa-trash-restore-alt"></i>
                            </Button>
                          </Can>
                        ),
                      ]
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  deleteUser: (id) => dispatch({ type: ASYNC_DELETE_USER, payload: { id } }),
  restoreUser: (id) => dispatch({ type: ASYNC_RESTORE_USER, payload: { id } }),
});

const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(UsersList);

export default MasterPage(reduxConnect);
